<template>
  <div class="pageContent">
    <el-tabs type="border-card" v-model="activeName" @tab-click="changeTabMethod" >
      <el-tab-pane label="影像检查" name="影像检查" v-if="itemTabDisplay[0]===1" >
        <diagnoseImageManage />
      </el-tab-pane>
      <el-tab-pane label="美容/治疗" name="美容/治疗" v-if="itemTabDisplay[1]===1" >
        <CosmetologyImgs></CosmetologyImgs>
      </el-tab-pane>
      <el-tab-pane label="住院" name="住院" v-if="itemTabDisplay[2]===1" >
        <InHospitalManager/>
      </el-tab-pane>
      <el-tab-pane label="黑色素瘤" name="黑色素瘤" v-if="itemTabDisplay[3]===1" >
        <MmInfoManager/>
      </el-tab-pane>
    </el-tabs>
    </div>
</template>

<script>
  import diagnoseImageManage from '../components/DiagnoseImageManage.vue';
  import CosmetologyImgs from '../components/CosmetologyImgs.vue';
  import InHospitalManager from '../components/InHospitalManager.vue';
  import MmInfoManager from '../components/MmInfoManager.vue';

  export default {
    name: 'ImageList',
    data() {
      return {
        activeName: '',
        // Tabs 根据权限设置那个Tab显示
        itemTabDisplay: [0,0,0,0],
        defaultItemTabs: [
          {label: "影像检查",name: "影像检查"},
          {label: "美容/治疗",name: "美容/治疗"},
          {label: "住院",name: "住院"},
          {label: "黑色素瘤",name: "黑色素瘤"}
        ],
        tabStyle: ""
      }
    },
    watch: {},
    mounted() {
      let auths = this.$store.state.controller.auths;
      // 后台限制，最少要有一种模态，如果管理员设置全未选，则保留大体图一种模态。2025-01-08
      let image_modality = this.$store.state.controller.intellModel;
      // console.log("In search, user auths and image_modality:",auths,image_modality);


      if(auths.indexOf('inhospital_order')>-1){
        this.itemTabDisplay[2] = 1;
        this.activeName =  this.defaultItemTabs[2].name; 
      }
      if(auths.indexOf('export_cosmetology')>-1){
        this.itemTabDisplay[1] = 1;
        this.activeName =  this.defaultItemTabs[1].name; 
      }
      if(auths.indexOf('sd_mm')>-1){
        this.itemTabDisplay[3] = 1;
        this.activeName =  this.defaultItemTabs[3].name; 
      }
      if(image_modality.length>1){
        this.itemTabDisplay[0] = 1;   
        this.activeName =  this.defaultItemTabs[0].name;   
      }
      // 至少显示1个标签页
      if(this.itemTabDisplay[0]===0 && this.itemTabDisplay[1]===0 && this.itemTabDisplay[2]===0 && this.itemTabDisplay[3]===0){
        this.itemTabDisplay[0] = 1; 
        this.activeName =  this.defaultItemTabs[0].name;
      }   
      
      this.tabStyle = "width:" + (100/(this.itemTabDisplay[0]+this.itemTabDisplay[1]+this.itemTabDisplay[2]+this.itemTabDisplay[3])) + '%';
      // console.log(this.tabStyle);
      
    },
    methods: {
      changeTabMethod(tab, event){
        // console.log(tab, event);
      }
    },
    components: {
      diagnoseImageManage,
      CosmetologyImgs,
      InHospitalManager,
      MmInfoManager
    },
  
  };
</script>

<style scoped>
  
  
  /*dialog关闭按钮样式*/
  .pageContent .el-dialog__headerbtn{
    top: 10px;
    right: 22px;
    font-size: 24px;
  }
  .pageContent .el-icon-close::before{
    color: #61a2bf;
    font-weight: bold;
  }
</style>
<style  lang="less">
  @import '../assets/style/style.less';
  /*::-webkit-scrollbar {*/
    /*width: 5px;*/
    /*height: 100%;*/
  /*}*/
  
  /*::-webkit-scrollbar-track-piece {*/
    /*background: #fff;*/
    /*-webkit-border-radius: 6px;*/
  /*}*/
  
  /*::-webkit-scrollbar-thumb:vertical {*/
    /*background-color: #61a2bf;*/
    /*-webkit-border-radius: 6px;*/
  /*}*/

  .el-range-editor--mini.el-input__inner {
    width: 93%;
  }

  // 分页
  .pagination {
    display: flex;
    justify-content: center;
    left: 0;
    bottom: 0;
    width: 100%;
    padding-bottom: 20px;
   
    .current-page {
      color: @sColor;
      height: 40px;
      line-height: 40px;
      margin: 0 20px;
    }
  }

  // 右侧内容外部盒子样式
  .right-content-wrap {
    position: relative;
    width: 100%;

    .right-content-wrap-main {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 60px;
    }
  }

  .pageContent {
    position: absolute;
    left: 0;
    top: 50px;
    bottom: 0;
    right: 0;
    background: #fff;

    .headTitle {
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #4e839b;

      .headItem {
        width: 50%;
        padding: 8px 0;
        text-align: center;
        font-size: 13px;
        font-weight: 500;
        color: #5a6d7e;
        box-sizing: border-box;
        border-right: 1px solid #4e839b;
        cursor: pointer;
        transition: color .2s, background-color .2s;
      }

      .headItem:hover {
        color: #3a7ca5;
        background-color: #eef2f5;
      }

      .headItem.is-active {
        color: #2c5f8a;
        background-color: #c0d5dd;
        font-weight: 600;
      }

      .headItem:nth-child(2) {
        border-right: 0 solid #ebebeb;
      }
    }

    .leftCon {

      .formWrapper {
        padding: 10px;

        .patient-wrapper {
          margin-bottom: 18px;
          display: flex;
          align-items: center;

          .sex-con {
            display: flex;
            align-items: center;

            .label {
              font-size: 14px;
              color: #606266;
              margin-right: 12%;
              white-space: nowrap;
            }
          }

          .race-con {
            align-items: center;

            .label {
              font-size: 14px;
              color: #606266;
              margin-right: 12%;
              white-space: nowrap;
            }
          }
        }

        .moreWrapper {
          position: relative;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          height: 24px;

          .moreBtn {
            width: 100px;
            background: #61a2bf;
            color: #fff;
            padding: 5px 0;
            margin-right: 5px;
            border-radius: 5px;
            cursor: pointer;
            text-align: center;
          }
        }
      }
    }

    .rightCon {
      width: 100%;

      .filterCon {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .filterItem {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          background: #ebebeb;
          padding: 10px 20px;
          margin-left: 10px;
          margin-bottom: 5px;
          border-radius: 5px;
          font-size: 14px;
          user-select: none;

          .close-btn {
            width: 16px;
            height: 16px;
            color: #666;
            margin-left: 10px;
            border-radius: 50%;
            text-align: center;
            line-height: 16px;
            cursor: pointer;
            user-select: none;
            font-size: 16px;
          }

          .close-btn:hover {
            color: #888;
          }
        }
      }

      .filter-count {
        display: flex;
        justify-content: flex-end;
        align-items: center;
     /*   height: 60px;*/
         margin-bottom: 20px;
        .download-btn-wrap {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: row-reverse;
          width: 180px;
          margin-right: 84px;

          .download-btn {
            width: 85px;
            height: 25px;
            color: #fff;
            border-radius: 6px;
            background-color: #49a2c2;
            text-align: center;
            line-height: 26px;
            font-size: 14px;
            box-shadow: 3px 3px 5px #888;
            cursor: pointer;
            user-select: none;
          }
        }
      }

      .diagnoses-con {
  
        margin-left: 3%;
        width: 97%;

        .moreItem {
          .check-box {
            
            float: left;
            display: flex;
            justify-content: center;
            align-items: center;
            min-width: 292px;
            max-width: 325px;
            width: 31%;
            height: 128px;
            background: #EBEBEB;
            border-radius: 20px;
            box-shadow: 5px 5px 5px #888888;
            margin-right: 2%;
            margin-bottom: 16px;
            padding: 10px;
            box-sizing: border-box;
            overflow: hidden;

            .img-box {
              width: 84px;
              height: 84px;
              margin-right: 15px;
              overflow: hidden;

              .check-img {
                max-height: 100px;
                height: 84px;
                width: 78px;
              }
            }

            .check-info {
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              width: 190px;
              height: 88px;

              p {
                color: #4AA3C4;
                margin-bottom: 4px;
                font-size: 12px;
              }
            }
          }
        }

        .moreItem::after {
          content: '';
          display: block;
          clear: both;
        }

        /*.pagination {
          display: flex;
          justify-content: center;

          .current-page {
            color: #409eff;
            height: 40px;
            line-height: 40px;
            margin: 0 20px;
          }
        }*/
      }

      .diagnoses-con2 {
        width: 100%;

        .content {
          .moreItem {
            width: 100%;

            .images-item {
              float: left;
              position: relative;
              width: 175px;
              height: 130px;
              margin-right: 2%;
              margin-bottom: 20px;
              border-radius: 5px;
              box-shadow: 3px 3px 5px #888;
              overflow: hidden;

              .image {
                width: 100%;
                height: 100%;
              }

              .download-btn-box {
                display: flex;
                align-items: center;
                position: absolute;
                right: 2px;
                top: 2px;
                padding: 2px;
                border-radius: 5px;
                background-color: rgba(0, 0, 0, .4);

                .botton {
                  width: 16px;
                  height: 15px;
                  border-radius: 2px;
                  user-select: none;
                  cursor: pointer;
                  text-align: center;
                  line-height: 15px;
                }

                .download-btn {
                  color: #fff;
                }

                .selected-btn {
                  background-color: #fff;
                  margin-left: 15px;
                  color: #444;
                }
              }
            }
          }

          .moreItem::after {
            content: '';
            display: block;
            clear: both;
          }

          .show-image {
            display: flex;
            justify-content: center;
            align-items: center;
            position: fixed;
            top: 60px;
            left: 329px;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, .6);

            .pic {
              width: 80%;
              height: 80%;
              background-size: contain;
              background-position: center center;
              background-repeat: no-repeat;
            }
          }
        }

        /*.pagination {
          display: flex;
          justify-content: center;

          .current-page {
            color: #409eff;
            height: 40px;
            line-height: 40px;
            margin: 0 20px;
          }
        }*/
      }
    }

    .details-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, .9);

      .aside {
        color: #fff;
        padding-left: 20px;
        padding-top: 20px;
        font-size: 14px;

        ul {
          li {
            margin-bottom: 10px;
          }
        }
      }

      .showPic {
        position: absolute;
        left: 260px;
        top: 0;
        bottom: 0;
        right: 200px;
        border: 1px solid #eee;
        box-sizing: border-box;
        overflow: hidden;
        user-select: none;

        .img {
          position: absolute;
        }
      }

      .right-box {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 200px;

        .close-pic-btn {
          position: absolute;
          top: 30px;
          right: 30px;
          width: 40px;
          height: 40px;
          color: #fff;
          text-align: center;
          line-height: 40px;
          font-size: 40px;
          cursor: pointer;
          user-select: none;
          z-index: 3;
        }
      }
    }
  }
  .ellipsisP{
    flex: 1;
    display: flex;
  }
  .ellipsisSpan{
    flex: 1;
    width: 1px;
    text-align: left;
  }
  .modify-btn:hover{
    color: #ff7979 !important;
  }

  .show-more-text{
    color: rgb(97,162,191);
    font-size: 17px;
    font-weight: bold;
    cursor: pointer
  }
  .show-more-btn{
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgb(97,162,191);
    font-size: 19px;
    cursor: pointer;
  }
  .el-tabs__header{
    margin-bottom: 0px
  }
  .el-tab-pane{
    height: 100%;
  }
  .el-tabs__nav{
    float: none;
    text-align: -webkit-center;
    text-align: center;
  }
  .el-tabs__item{
    font-size: 14px;
    font-weight: 600;
    color: #5a6d7e;
    padding: 0 8px;
    height: 38px;
    line-height: 38px;
    transition: color .2s, background-color .2s;
  }
  .el-tabs__item:hover{
    color: #3a7ca5;
    background-color: #eef2f5;
  }
  .el-tabs--border-card{
    height: 100%;
    border:0;
    -webkit-box-shadow:0 0px 0px 0 rgb(212, 13, 13), 0 0 0px 0 rgba(0,0,0,.04);
    box-shadow:0 0px 0px 0 rgba(0,0,0,.12), 0 0 0px 0 rgba(0,0,0,.04);
    overflow: hidden;
  }
  .el-tabs--border-card>.el-tabs__content{
    padding: 0px;
    height: 100%;
  }
  .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
    color: #2c5f8a;
    background-color: #f5f8fa;
    border-bottom: 3px solid #3a7ca5;
  }
  .pageContent .rightCon{
    height: 100%;
  }
  .el-tabs--border-card>.el-tabs__header {
    background-color: #e8ecf0;
    width: 360px;
    border-bottom: 1px solid #4e839b;
  }
  
   #iconfontR{
  
     font-size: 12px;color: #177899;font-weight: bold;
   }
  .iconfontRFather{
    border-radius: 5px;
    border: 2px solid #2B7087;
    cursor: pointer;
    width: 13px;
    height: 13px;
    position: relative;
    bottom: 38px;
    right: 16px;
    background-color: #C7D7DD;
  }


</style>



